import { useState } from 'react'

import { Tooltip } from 'core-components/library/tooltip'
import { useLineClampedText } from 'shared/lib/lineClamp'

import styles from './TruncatedValue.module.scss'

const MAX_LINES = 2

interface ITruncatedValueProps {
  value: string
}

export const TruncatedValue = ({ value }: ITruncatedValueProps) => {
  const { ref, isTruncated } = useLineClampedText(value, MAX_LINES)
  const [focused, setFocused] = useState(false)

  return (
    <Tooltip tipContent={() => <span>{value}</span>} textAlign="left" disabled={!isTruncated}>
      <span
        ref={ref}
        className={styles.value}
        tabIndex={isTruncated || focused ? 0 : undefined}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      >
        {value}
      </span>
    </Tooltip>
  )
}
